// Public, read-only pages (PolicyDocumentPage) so signup can link to the documents
// instead of walking users through the acceptance wizard. The guards' skip lists
// include these paths. Kept apart from the page so linking to it doesn't pull in
// react-markdown.
export const POLICY_PAGE_PATHS = {
  privacy: '/legal/privacy',
  eula: '/legal/eula',
} as const;

export type PolicyPageDoc = keyof typeof POLICY_PAGE_PATHS;

export const POLICY_PAGE_PATH_LIST: readonly string[] = Object.values(POLICY_PAGE_PATHS);

export const isPolicyPagePath = (pathname: string): boolean => POLICY_PAGE_PATH_LIST.includes(pathname);
